<template>
    <div v-bind:class="{expanded: leftMenuExpanded}" class="app-container">

        <Spinner v-if="isAppLoading" v-bind:title="'Loading Pelican..'"></Spinner>

        <div v-if="!isAppLoading" class="row content-container">

            <nav class="navbar navbar-default navbar-fixed-top navbar-top" id="navbar-id">
                <div class="container">
                    <div class="navbar-header">
                        <button
                                v-on:click="toggleLeftMenu"
                                v-bind:class="{'fa-rotate-90': leftMenuExpanded}"
                                type="button"
                                class="navbar-expand-toggle">
                            <i class="fa fa-bars icon"></i>
                        </button>
                        <ol class="breadcrumb navbar-breadcrumb">
                            <li class="active">
                                {{ user.pseudo }}
                            </li>
                        </ol>

                        <RouterLink to="balance_and_transactions" v-if="user.workerIsNovice !== true">
                            <span class="credit-header" v-if="!leftMenuExpanded" :class="{'negatif-credit':user.lastBalance<=0}">
                                {{user.lastBalance|roundNumber}} {{ $currency.symbol(user.country)}}
                            </span>
                        </RouterLink>

                        <span class="badge-points-header" v-if="user.workerIsNovice !== true">
                            <RouterLink to="badges">
                                <img :src="getBadgeUrl()"
                                     class="navbar-right-expand-toggle pull-right img-badge">
                                <span class="badge-points">
                                    {{positifFormating(user.badgePoints)}}
                                </span>
                            </RouterLink>
                        </span>
                    </div>
                </div>
            </nav>

            <LeftMenu v-if="leftMenuExpanded" v-on:menu:close="closeLeftMenu" v-bind:user="user">
            </LeftMenu>

            <!-- Main Content -->
            <div class="container">
                <div class="content-side-body padding-top">
                    <div class="alert alert-danger text-center" v-show="isAppLoading === false && user.isLoggedIn === false">
                        {{'Please log in to continue'|trans}}
                        <a v-bind:href="loginUrl" class="btn btn-primary btn-sm">LOG IN</a>
                    </div>
                    <router-view v-bind:user="user"></router-view>
                    <badge_modal_new v-bind:currentBadge="getCurrentBadge()" :workerId="user.user_id" v-if="!isAppLoading && user.hasNewBadge"></badge_modal_new>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import "../../../src/PelicanBundle/Resources/public/theme/lib/js/jquery.min.js";
    import "../../../src/PelicanBundle/Resources/public/theme/lib/js/bootstrap.min.js";
    import "../../../src/PelicanBundle/Resources/public/theme/lib/js/bootstrap-switch.min.js";
    import "../../../src/PelicanBundle/Resources/public/theme/lib/js/jquery.matchHeight-min.js";
    import "../../../src/PelicanBundle/Resources/public/theme/js/app-for-worker-interface.js"; // TODO PIERRE: absolument virer cette dépendance !
    import LeftMenu from './components/LeftMenu';
    import translations from './translations';
    import moment from 'moment-timezone';
    import Spinner from './components/Spinner';
	import badgesCollection from "./components/Badges/badges_collection";
	import badge_modal_new from "./components/Badges/badge_modal_new";

    export default {
        data() {
            return {
                user_name : '',
                leftMenuExpanded: false,
                rightMenuExpanded: false,
                user : {
                    lang : 'fr',
                    pseudo : null,
                    show_tutorial : false,
                    user_id : null,
                    isLoggedIn :false
                    // INFO: Pierre added a key 'workerZipCode' to the 'me' api call, but doesn't found mandatory to put some default value here
                },
                defaultLanguage : 'fr',
                isAppLoading : true,
                workerCredit : -100
            }
        },
        async created (){
            await this.checkUserCredentials();
            this.isAppLoading = false;
        },
        methods:{
        	getBadgeUrl(){
				let badge = this.getCurrentBadge();
        	    return process.env.VUE_APP_API_BASE_URL_ASSETS + "/images/badges/" + badge.img_name_blank;
            },
            getCurrentBadge() {
                return badgesCollection.find((element) => {
                    return element.badge_id === this.user.badgeId;
                });
            },
			absolutePath(image) {
				return process.env.VUE_APP_API_BASE_URL_ASSETS + image;
			},
            async checkUserCredentials() {
                this.user = await this.$api.user.me();
                this.$bugsnagClient['user'] = {
                    id: this.user.user_id,
                    name: this.user.pseudo
                };
                this.setUserLanguage(this.user.lang);
                this.user.isLoggedIn = true;
            },
            setUserLanguage(lang){
                window.translations = translations[lang];
				window.lang = lang;
                this.defaultLanguage = lang;
                moment.locale(lang);
            },
            // ---------------------------------------------------------------------------------------------------------
            toggleLeftMenu() {
                this.leftMenuExpanded = !this.leftMenuExpanded;
            },
            closeLeftMenu() {
                this.leftMenuExpanded = false;
            },
            openRightMenu() {
                this.rightMenuExpanded = true;
            },
            closeRightMenu() {
                this.rightMenuExpanded = false;
            },
			positifFormating(value){
				if(value > 0){
					return '+'+value;
				}
				return value;
			}
        },
        computed: {
            loginUrl() {
                return process.env.VUE_APP_API_BASE_URL;
            },
            logoutUrl() {
                // REMARK: not possible to use Routing.js for this route, because this route is internal in FOSUserBundle
                return process.env.VUE_APP_API_BASE_URL + '/admin/logout';
            }
        },
        components: {
			badge_modal_new,
            LeftMenu,
            Spinner,
        },
        filters: {
          roundNumber(number) {
            return number !== null ? Math.round(number) : number ;
            //return number.toFixed(2);
          },
        },
    }
</script>

<style lang="scss">
    @import '../../../src/PelicanBundle/Resources/public/theme/lib/css/bootstrap.min';
    @import '~font-awesome/css/font-awesome.css';
    @import '../../../src/PelicanBundle/Resources/public/theme/css/style';
    @import '../../../src/PelicanBundle/Resources/public/theme/css/themes/flat-blue';
    @import '../../../src/PelicanBundle/Resources/public/pelican/css/fragment';
    @import '../../../src/PelicanBundle/Resources/public/pelican/css/fragment-others';

    .navbar-header{
        width: 100%;
    }

    .credit-header{
        text-align: center;
        margin: 0 auto;
        width: 25%;
        font-size: 17px;
        padding: 5px;
        position: absolute;
        left: 40%;
        top: 13px;
        border-radius: 18px;
        background-color: #35464f;
        color:white;
        font-weight: bold;
    }

    .negatif-credit{
        background-color:red;
        color:white;
        animation: blink 1s;
        animation-iteration-count: 3;
    }

    @keyframes blink { 50% { background-color: #be0000
    }}



    .badge-points-header{
        position: relative;
        float:right;
        width: 60px;
        height: 60px;
        .badge-points{
            position: absolute;
            top: 18px;
            margin: 0 auto;
            z-index: 222;
            font-size: 14px;
            font-weight: bold;
            width: 100%;
            text-align: center;
        }
    }

    .navbar {
        padding-left: 0;
    }
    .red-btn{
        background-color:red;
        color: white;
    }
    .content-side-body{
        margin-top:74px;
    }

    a {
        cursor: pointer;
        text-decoration: none;
    }

    .tippy-content {
        font-size: 12px;
    }

    .vdp-datepicker .today{
        background: #2f353e;
        color:white;
    }

    .img-badge{
        width: 50px !important;
        height: 50px !important;
        margin: 6px;
        opacity: inherit !important;
    }


</style>
